import FeedbackFilterService from "./feedback-filter-service";
import MultCoachesBar from "../../../../components/mult-coaches-bar";
import Api from "../../../../lib/api";

export default class FilterController {
	constructor(props = {}) {
		this.$root = props.$root;
		this.$reviewsListContainer = document.getElementById('reviewsListContainer');
		this.$controls = null;
		this.$kidsControl = null;

		this.city = props.city || '*';
		this.category = props.category || '*';

		this.AFTER_INIT_EVENT = 'afterInit';
		this.VALUE_CHANGE_EVENT = 'valueChange';

		this.init();
	}

	init() {
		if (this.$root == null) {
			throw new Error('FilterController: Root element is not defined.');
		}

		if (this.$reviewsListContainer == null) {
			throw new Error('FilterController: Reviews list container is not defined.');
		}

		this.$kidsControl = this.$root.querySelector('[data-value="kids"]');
		this.switchKidsFilter();

		FeedbackFilterService.getReviews(this.city, this.category)
			.then((data) => {
				data = data.trim();

				if (data) {
					this.$reviewsListContainer.innerHTML = data;
					this.initMultCoachesBars();
					FeedbackFilterService.initVideo(this.$reviewsListContainer);
					lozadObserver.observe();
				}

				this.bootstrap();
				this.$root.dispatchEvent(new Event(this.AFTER_INIT_EVENT));
			});
	}

	bootstrap() {
		this.$controls = this.$root.querySelectorAll('[data-review-filter="control"]');
		this.addEventListeners();
	}

	addEventListeners() {
		this.$controls.forEach(($control) => {
			if ($control.classList.contains('radio')) {
				$control.querySelector('input').addEventListener('change', (e) => {
					this.onValueChange($control);

					if ($control.dataset.name === 'city') {
						this.switchKidsFilter();
					}
				});
			} else {
				$control.addEventListener('click', (e) => {
					this.onValueChange($control);

					if ($control.dataset.name === 'city') {
						this.switchKidsFilter();
					}
				});
			}
		});
	}

	onValueChange($control) {
		const name = $control.dataset.name;
		const value = $control.dataset.value;

		if (
			(name === 'city' && this.city === value) ||
			(name === 'category' && this.category === value)
		) return;

		if (name === 'city') {
			this.city = value;
		} else if (name === 'category') {
			this.category = value;
		}

		if (name === 'city' &&
			value === 'online' &&
			this.category === 'kids') return;

		this.changeValue();

		/* Event: VALUE_CHANGE_EVENT */
		this.$root.dispatchEvent(new CustomEvent(this.VALUE_CHANGE_EVENT, { detail: { name, value } }));
	}

	changeValue() {
		this.$reviewsListContainer.classList.add('-value-changing');

		FeedbackFilterService.getReviews(this.city, this.category)
			.then((data) => {
				data = data.trim();

				if (data) {
					this.$reviewsListContainer.innerHTML = data;
					this.initMultCoachesBars();
					FeedbackFilterService.initVideo(this.$reviewsListContainer);
					lozadObserver.observe();
				}

				this.$reviewsListContainer.classList.remove('-value-changing');
			});
	}

	getUrl() {
		return `${craft.env.apiSiteUrl}/feed/studentReviews?currentCity=${Api.currentCityId}&city=${this.city}&category=${this.category}`;
	}

	initMultCoachesBars() {
		const $bars = this.$reviewsListContainer.querySelectorAll('.mult-coaches-bar');

		if ($bars.length) {
			$bars.forEach(($bar) => {
				const multCoachesBar = new MultCoachesBar({ $root: $bar });
			});
		}
	}

	switchKidsFilter() {
		if (!this.$kidsControl) {
			return;
		}

		if (this.city === 'online') {
			this.$kidsControl.style.display = 'none';

			if (this.category === 'kids') {
				const $control = Array.from(this.$controls).find(($control) => ($control.dataset.name === 'category' && $control.dataset.value === '*'))

				const $input = $control.querySelector('[type="radio"]');

				if ($input) {
					$input.checked = true;
					$input.dispatchEvent(new Event('change'));
				} else {
					$control.dispatchEvent(new Event('click'));
				}
			}
		} else {
			this.$kidsControl.style.display = null;
		}
	}
}